import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Avatar,
  Dialog,
} from "@mui/material";
import { apiCallUserReferCoinEarnHistory } from "../../../../Core/Apicall";
import { useLocation } from "react-router-dom";
import CommonPagination from "../../../Common/CommonPagination/CommonPagination";
import EmptyData from "../../../Common/EmptyData/EmptyData";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import dayjs from "dayjs";

const ReferralCoinEarn: React.FC = () => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedMediaForPreview, setSelectedMediaForPreview] = useState<
    any | null
  >(null);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [totalItems, setTotalItems] = useState(0);
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const location = useLocation();
  const useData = location.state.user;

  const handleApiCall = async (userId: any) => {
    setLoading(true);

    try {
      const data = {
        userId,
        offset: page,
        limit: rowsPerPage,
      };
      const res = await apiCallUserReferCoinEarnHistory(data);
      setTableData(res?.data);
      setTotalItems(res?.totalCount || 0);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleApiCall(useData.userId ? useData.userId : useData._id);
  }, [page, rowsPerPage, useData]);

  const handlePageChange = (value: number) => {
    setPage(value);
  };

  return (
    <Box sx={{ p: "20px" }}>
      <Paper
        className="scroll-bar"
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <TableContainer className="scroll-bar">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Profile Image</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Coins</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>
            {loading === false && (
              <TableBody>
                {tableData.map((item: any) => (
                  <TableRow key={item._id}>
                    <TableCell style={{ cursor: "pointer" }}>
                      <Avatar
                        variant="rounded"
                        src={item?.profileImagePath}
                        sx={{ width: 65, height: 65, borderRadius: "100px" }}
                        onClick={() =>
                          setSelectedMediaForPreview({
                            type: "Image",
                            url: item?.profileImagePath,
                          })
                        }
                      />
                    </TableCell>
                    <TableCell>{item.fullName}</TableCell>
                    <TableCell>{item.coins}</TableCell>
                    <TableCell>{item.coinType}</TableCell>
                    <TableCell>
                      {dayjs(item.createdAt).format(
                        "DD MMM YYYY, hh:mm A"
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            )}
          </Table>

          {loading === true && (
            <div style={{ padding: "10px 10px" }}>
              <CommonShimmer />
            </div>
          )}
          {loading === false && <EmptyData data={tableData} />}
        </TableContainer>

        <CommonPagination
          page={page}
          rowsPerPage={rowsPerPage}
          totalItems={totalItems}
          totalPages={totalPages}
          onPageChange={(value) => handlePageChange(value)}
          onRowsPerPageChange={(value) => {
            setRowsPerPage(value);
            setPage(1);
          }}
        />
      </Paper>

      <Dialog
        open={!!selectedMediaForPreview}
        onClose={() => setSelectedMediaForPreview(null)}
      >
        {selectedMediaForPreview?.type === "Image" ? (
          <Avatar
            src={selectedMediaForPreview.url}
            variant="rounded"
            sx={{ width: 300, height: "auto" }}
          />
        ) : selectedMediaForPreview?.type === "Video" ? (
          <video width="300" controls autoPlay>
            <source src={selectedMediaForPreview.url} type="video/mp4" />
          </video>
        ) : null}
      </Dialog>
    </Box>
  );
};

export default ReferralCoinEarn;
